//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"AlignmentPosition",1,0],[0,"ApplyToAllSections",1,0],[0,"BorderOffset",1,0],[0,"ContinuationNote",1,0],[0,"ContinuationProperty",1,0],[0,"ContinuationSpacing",1,0],[0,"DisplayContinuationNote",1,0],[0,"DoubleBorder",1,0],[0,"HeaderLocation",1,0],[0,"MaximumHeight",1,0],[0,"RowHeight",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.TableSectionStyleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TableSectionStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.TableSectionStyleBuilder.LocationOfHeader = Object.freeze({
    "Above" : "Above", "Below" : "Below", "None" : "None"});

SPLM.Annotations.TableSectionStyleBuilder.ContinuationPropertyType = Object.freeze({
    "Left" : "Left", "Right" : "Right", "Up" : "Up", "Down" : "Down", "NextSheet" : "NextSheet"});

SPLM.Annotations.TableSectionStyleBuilder.AlignmentPositionType = Object.freeze({
    "TopLeft" : "TopLeft", "TopRight" : "TopRight", "BottomLeft" : "BottomLeft", "BottomRight" : "BottomRight"});

SPLM.Annotations.TableSectionStyleBuilder.DisplayContinuationNoteType = Object.freeze({
    "None" : "None", "Above" : "Above", "Below" : "Below"});

export default SPLM;